export type Cell = 0 | 1 | 2 | 3 | 4;
export type Piece = 0 | 1 | 2 | 3 | 4;
export const EMPTY: Piece = 0;
export const RED: Piece = 1;
export const BLACK: Piece = 2;
export const RED_KING: Piece = 3;
export const BLACK_KING: Piece = 4;

export interface CheckersGame {
  board: Piece[][];
  turn: 1 | 2;
  winner: 0 | 1 | 2;
  isDraw: boolean;
  mustJump: boolean;
  jumpPositions: Array<{ r: number; c: number }>;
  selected: { r: number; c: number } | null;
  validMoves: Array<{ r: number; c: number; jump: boolean; captured?: { r: number; c: number } }>;
  multiJump: { r: number; c: number } | null;
}

export const SIZE = 8;
